import React from 'react'
import { ExchangeContainer } from './Exchange.styled'
import ExchangePageImage from '../../assets/exchange_page_image.png'

const Exchange = () => {
  return (
    <ExchangeContainer>
      {/* <span style={{color: "#AC58E2", textTransform: "uppercase"}}>Coming Soon</span> */}
      <img
        src={ExchangePageImage}
        alt="exchange page img"
        height={250}
        width={250}
      />
      <h3>Exchange is coming soon</h3>
      <span>We'll let you know when it's ready</span>
    </ExchangeContainer>
  )
}

export default Exchange